import {qs} from "../utils/dom.js";
import {appState} from "../state/app-state.js";
import {navigateToOffer} from "../utils/navigation.js";

export function renderApp() {
  const mount = qs("#app");
  if (!mount) {
    return;
  }

  const allButtons = document.querySelectorAll(".appButton");
  allButtons.forEach((button) => {
    if (appState.offer) {
      button.setAttribute("href", `/casino/${appState.offer.id}`);
    }
    button.addEventListener("click", (ev) => {
      ev.preventDefault();

      if (appState.offer) {
        navigateToOffer(appState.offer.id, appState.offer.link);
      }
    });
  });

  mount.querySelectorAll(".downloadBlock img").forEach((img) => {
    img.addEventListener("click", (ev) => {
      ev.preventDefault();
      if (appState.offer) {
        navigateToOffer(appState.offer.id, appState.offer.link);
      }
    });
  });
}
